// extracted by mini-css-extract-plugin
export default {"ingrediensblock":"nZ","heading":"oZ","item":"pZ","fadeIn":"qZ","imagewrapper":"rZ","modalheader":"sZ","amount":"tZ","name":"uZ","desc":"vZ","moredetails":"wZ","ingheader":"xZ"};
    if(module.hot) {
      // 1713211527025
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  